<template>
	<div>
		<div id="event-name">
			<a :href="link" v-if="link" target="_blank" rel="noopener">{{ name }}</a>
			<label v-else>{{ name }}</label>
			<label id="suffix">提出作品</label>
		</div>
		<div id="event-banner" v-if="bannerPath">
			<a :href="link" v-if="link" target="_blank" rel="noopener">
				<img :src="bannerPath" />
			</a>
			<img :src="bannerPath" v-else />
		</div>
	</div>
</template>

<script>
export default {
	props: {
		link: {
			type: String,
		},
		name: {
			type: String,
		},
		bannerPath: {
			type: String,
		}
	}
}
</script>

<style scoped>
	#event-name {
		margin: 16px 0;
	}
	#suffix {
		margin-left: 8px;
	}
</style>